/**
 * Brand-token-bound chart palette. Each entry resolves to a CSS variable
 * defined in tokens.css / tailwind.css, so dark mode + tenant-branded
 * themes flow through automatically. Recharts components accept these
 * raw `var(--token)` strings as `stroke` / `fill` / `color` values.
 */
export const CHART_COLORS = {
  brand: 'var(--color-brand)',
  brandSubtle: 'var(--color-brand-subtle)',
  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
  danger: 'var(--color-danger)',
  info: 'var(--color-info)',
  neutral: 'var(--color-fg-muted)',
  border: 'var(--color-border)',
  bg: 'var(--color-bg)',
  fg: 'var(--color-fg)',
  fgMuted: 'var(--color-fg-muted)',
} as const;

/** Ordered series palette for multi-line / stacked-bar charts. */
export const SERIES_PALETTE = [
  CHART_COLORS.brand,
  CHART_COLORS.info,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
];
